
























import { handleError } from "@/lib/utility/handleError";
import { IInvoice } from "@/models/invoice.entity";
import Vue from "vue";
import { mixins } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";
import LatestEntriesCardEmpty from "../cards/LatestEntriesCardEmpty.vue";
import SideCard from "../utility/SideCard.vue";
import InvoiceDetail from "./InvoiceDetail.vue";
import { IGroupTypeEntitySideCard } from "@/lib/utility/group/interface/group-type-entity-side-card.interface";

@Component({
  components: { SideCard, InvoiceDetail, LatestEntriesCardEmpty }
})
export default class InvoiceSideCard extends mixins(Vue) implements IGroupTypeEntitySideCard {
  @Prop()
  value!: IInvoice;

  get fullscreenBreakpoint() {
    return this.$vuetify.breakpoint.width < 1500;
  }

  isLoading = false;

  async mounted() {
    try {
      this.isLoading = true;

      await this.value.fetch();
    } catch (error) {
      handleError(error);
    } finally {
      this.isLoading = false;
    }
  }

  close() {
    this.$emit("close");
  }
}
